import type { LivescoreCompetition } from '../store/types';

import { RoundPhase } from '@shared-types/match.types';

export const getCompCode = (competition: LivescoreCompetition, phase?: RoundPhase) => {
  competition.phase ??= phase;

  if (competition.id === '3' && competition.phase === RoundPhase.TOURNAMENT) return 'euro2024';
  if (competition.id === '18' && competition.phase === RoundPhase.QUALIFYING) return 'weq';
  if (competition.id === '18' && competition.phase === RoundPhase.PREQUALIFYING) return 'uwnl';
  if (competition.id === '39' && competition.phase === RoundPhase.QUALIFYING) return 'weq';
  if (competition.id === '39' && competition.phase === RoundPhase.PREQUALIFYING) return 'uwnl';
  if (competition.id === '19') return 'friendlies';

  return competition.code?.toLowerCase();
};
